import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {

    const {
        images: {logo}
    } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState
    const img = logo ? logo : toAbsoluteUrl('/media/logos/Logo-WF_1.png')

    return (
        <div className="splash-screen">
            <img src={img} alt="Start logo" />
        </div>
    )
}
